export let IntegrationStatus = /*#__PURE__*/function (IntegrationStatus) {
  IntegrationStatus["Linked"] = "linked";
  IntegrationStatus["Unlinked"] = "unlinked";
  IntegrationStatus["Paused"] = "paused";
  IntegrationStatus["Error"] = "error";
  return IntegrationStatus;
}({});